import { TABLE_DATA2 } from "../actions/actionTypes";
import { call, put, takeLatest } from "redux-saga/effects"
import { tableData } from './../actions/index';
import { fetchData } from "./api";

function* getApiData(action) {
    try {
        const data = yield call(fetchData, action.payload);
        yield put(tableData(data))
    } catch (e) {
        console.log(e)
    }
}


export default function* mySaga() {
    yield takeLatest(TABLE_DATA2, getApiData)
}